export default __webpack_public_path__ + "static/media/email-pen.5af147c9.svg";